"use client";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import useIsRtl from "@/hooks/useIsRtl";

const SvgGoBack = () => {
  const router = useRouter();
  const isRtl = useIsRtl();
  return (
    <svg
      onClick={() => router.back()}
      style={{
        color: "var(--dark)",
        ...(isRtl ? { display: "block", transform: "scale(-1,1)" } : {}),
      }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9844 3.19218C15.7766 3.19837 15.5793 3.28524 15.4344 3.43437L7.43442 11.4344C7.28444 11.5844 7.2002 11.7879 7.2002 12C7.2002 12.2121 7.28444 12.4156 7.43442 12.5656L15.4344 20.5656C15.5081 20.6424 15.5964 20.7037 15.6941 20.7459C15.7918 20.7882 15.897 20.8105 16.0034 20.8115C16.1098 20.8126 16.2154 20.7925 16.314 20.7522C16.4125 20.712 16.502 20.6525 16.5773 20.5772C16.6526 20.502 16.7121 20.4125 16.7523 20.3139C16.7925 20.2154 16.8127 20.1098 16.8116 20.0034C16.8105 19.8969 16.7882 19.7918 16.746 19.6941C16.7037 19.5964 16.6424 19.5081 16.5657 19.4344L9.13129 12L16.5657 4.56562C16.6813 4.45325 16.7602 4.30858 16.7922 4.15056C16.8242 3.99254 16.8076 3.82856 16.7448 3.68009C16.682 3.53162 16.5758 3.4056 16.4401 3.31853C16.3044 3.23147 16.1456 3.18743 15.9844 3.19218Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgGoBack;
